module.exports = __webpack_public_path__ + "static/00001.d9e1b32c.jpg";